/*eslint-disable*/
import React, {
  FC,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState
} from 'react'
import { QuestionnaireContext } from './QuestionnaireContext'
import { ReactComponent as Highlighter } from 'assets/img/highlighter.svg'
import Eraser from 'assets/img/eraser.svg'
import Calculator from 'assets/img/calculator.svg'
import RedMarker from 'assets/img/red-marker.svg'
import Close from 'assets/img/remove-icon-bold.svg'
import Cookies from 'js-cookie'
import {
  initDrawing,
  bindDrawing,
  unbindDrawing,
  eraseDrawing,
  bindEraser,
  unbindEraser,
  initDrawingQuestions,
  bindDrawingQuestions,
  unbindDrawingQuestions,
  bindEraserQuestions,
  unbindEraserQuestions
} from 'util/RaphaelInit'
import { showDesmosCalculator } from 'util/getCalculator'
import { useFormulaSheet } from 'hooks/useFormulaSheet'
import OpenLink from 'assets/img/link-icon.png'

interface Props {
  onRemoveHighlighter: () => void
  onClickHighLighter: (value: Function) => void
  onDestroyHighlighter: () => void
  onDestroyHighlighterRemover: () => void
  onRemoveAllHighlights: () => void
}

let calculator: any = null

export const getCalculator = () => {
  return calculator
}
export const setCalculator = (calc: any) => {
  calculator = calc
}
const Footer: FC<Props> = (props): React.JSX.Element => {
  const {
    getCalculatorElement,
    closeCalculator,
    destroyCalculator,
    questionIdx,
    setIsScreenMarked,
    setShowHighlightEraser,
    showHighlightEraser,
    setIsPencilActive,
    isPausedByTeacher,
    isPencilActive,
    setIsHighlighterActive,
    isHighlighterActive,
    setShowCalculator,
    showCalculator,
    setShowFinishModal,
    hasPreviousQuestion,
    hasNextQuestion,
    previousQuestion,
    nextQuestion,
    currentQuestion,
    setShowClearModal,
    setShowPauseExitModal,
    grade,
    audioRef,
    sketchWidth,
    sketchHeight,
    sketchHeightQues,
    sketchWidthQues
  } = useContext(QuestionnaireContext)

  const isCalculatorAllowed =
    Cookies.get('allow_calculator') === 'true' ||
    Cookies.get('allow_ti84_calculator') === 'true'
  const isMath = Cookies.get('isMath') === 'true'
  const { isScreenMarked } = currentQuestion

  const formulaSheet = useFormulaSheet()

  const [enableEraser, setEnableEraser] = useState(false)
  const [enableHighlightEraser, setEnableHighlightEraser] = useState(false)
  const [showHighlighterTooltip, setShowHighlighterTooltip] = useState(false)
  const [showPencilTooltip, setShowPencilTooltip] = useState(false)
  const [svgCreated, setSvgCreated] = useState(false)
  const [quesSvgCreated, setQuesSvgCreated] = useState(false)

  const markRef = useRef<any>(true)
  const eraseRef = useRef<any>(true)

  useEffect(() => {
    destroyCalculator()
    setShowHighlighterTooltip(false)
    setShowPencilTooltip(false)
    setEnableEraser(false)
    setEnableHighlightEraser(false)
    setShowHighlightEraser(false)
    setIsPencilActive(false)
    setIsHighlighterActive(false)
  }, [questionIdx])

  useEffect(() => {
    if (enableEraser && !isScreenMarked) {
      setIsScreenMarked(true)
    }
  }, [enableEraser])

  useEffect(() => {
    if (
      sketchWidth !== undefined &&
      sketchHeight !== undefined &&
      !svgCreated
    ) {
      initDrawing(sketchWidth, sketchHeight)
      setSvgCreated(true)
      return () => {
        document.removeEventListener('click', handler)
      }
    }
  }, [sketchHeight, sketchWidth])

  useEffect(() => {
    if (
      sketchWidthQues !== undefined &&
      sketchHeightQues !== undefined &&
      !quesSvgCreated
    ) {
      initDrawingQuestions(sketchWidthQues, sketchHeightQues)
      setQuesSvgCreated(true)
      return () => {
        document.removeEventListener('click', handler)
      }
    }
  }, [sketchWidthQues, sketchHeightQues])
  useEffect(() => {
    if (isPencilActive) {
      eraseRef.current = false
      bindDrawing(setIsScreenMarked)
      bindDrawingQuestions(setIsScreenMarked)
    } else {
      eraseRef.current = true
      markRef.current && unbindDrawing()
      markRef.current && unbindDrawingQuestions()
    }
  }, [isPencilActive])

  const handler = useCallback((event: any) => {
    const elem = event.target
    if (
      elem.nodeName === 'path' &&
      (elem.parentNode.id === 'sketch-container' ||
        elem.parentNode.id === 'sketch-container-questions')
    ) {
      elem.remove()
    }
  }, [])

  useEffect(() => {
    if (enableEraser) {
      markRef.current = false
      setIsPencilActive(false)
      unbindDrawing()
      unbindDrawingQuestions()
      bindEraser(setIsScreenMarked)
      bindEraserQuestions(setIsScreenMarked)
      document.addEventListener('click', handler)
    } else {
      markRef.current = true
      if (eraseRef.current) {
        unbindEraser()
        unbindEraserQuestions()
      }
      document.removeEventListener('click', handler)
    }
  }, [enableEraser])

  useEffect(() => {
    if (!isHighlighterActive) {
      props.onDestroyHighlighter()
    } else {
      props.onDestroyHighlighterRemover()
      props.onClickHighLighter((isMarked: boolean) => {
        setIsScreenMarked(isMarked)
        setEnableHighlightEraser(isMarked)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHighlighterActive])

  useEffect(() => {
    if (showHighlightEraser) {
      props.onRemoveHighlighter()
    } else {
      props.onDestroyHighlighterRemover()
    }
  }, [showHighlightEraser])

  useEffect(() => {
    return () => {
      eraseRef.current = false
      markRef.current = false
      unbindDrawing()
      unbindDrawingQuestions()
      unbindEraser()
      unbindEraserQuestions()
    }
  }, [])

  const onClickHighlighter = (isShow: boolean) => {
    setShowHighlighterTooltip(isShow)
    setShowPencilTooltip(false)
    setIsHighlighterActive(isShow)
    setIsPencilActive(false)
    setEnableEraser(false)
    setShowHighlightEraser(false)
    closeCalculator()
  }

  const onSelectHighlighter = () => {
    setIsHighlighterActive(true)
    setIsPencilActive(false)
    setEnableEraser(false)
    setShowHighlightEraser(false)
  }

  const onClickEraser = () => {
    // setIsScreenMarked(false);
    setEnableEraser((prev) => !prev)
    setIsHighlighterActive(false)
    setShowHighlightEraser(false)
  }

  const onClickHighlightEraser = () => {
    setShowHighlightEraser(!showHighlightEraser)
    setIsHighlighterActive(false)
    setIsPencilActive(false)
    setEnableEraser(false)
  }

  const onClosePencilTooltip = () => {
    onClickPencil(false)
  }

  const onCloseHighlightTooltip = () => {
    onClickHighlighter(false)
  }

  const onSelectPencil = () => {
    setIsPencilActive(true)
    setIsHighlighterActive(false)
    setEnableEraser(false)
    setShowHighlightEraser(false)
  }

  const onClickPencil = (isShow: boolean) => {
    setShowPencilTooltip(isShow)
    setIsPencilActive(isShow)
    setShowHighlighterTooltip(false)
    setIsHighlighterActive(false)
    setEnableEraser(false)
    setShowHighlightEraser(false)
    closeCalculator()
  }

  const onClearAllPencil = () => {
    eraseDrawing()
    setEnableEraser(false)
  }

  const openCalculator = () => {
    const elt = getCalculatorElement()
    if (!elt || calculator) return

    setShowCalculator(true)
    elt.style.display = 'block'
    elt.style.width = '400px'
    elt.style.height = '600px'
    calculator = showDesmosCalculator(grade, elt)
    setTimeout(() => {
      elt.style.height = 'auto'
      elt.style.maxHeight = '650px'
    }, 0)
  }

  const onClickCalculator = () => {
    if (showCalculator) {
      closeCalculator()
    } else {
      onClosePencilTooltip()
      onCloseHighlightTooltip()
      openCalculator()
    }
  }

  const clearPencil = () => {
    setIsPencilActive(false)
    setIsHighlighterActive(false)
  }

  const onClickFinish = async () => {
    clearPencil()
    setShowFinishModal(true)
  }

  const onClickFormulaSheet = () => {
    window.open(formulaSheet)
  }
  return (
    <footer className='cmsFooter'>
      <div className='pg-container'>
        <div className='cmsFooter-wrapper'>
          <div className='cmsFooter__search'>
            <div style={{ position: 'relative' }}>
              {showHighlighterTooltip && (
                <div className='edit-options-tooltip'>
                  <span
                    className={`cmsFooter__tools ${
                      isHighlighterActive ? 'cmsFooter__tools-border' : ''
                    }`}
                  >
                    <Highlighter
                      style={{ cursor: 'pointer' }}
                      onClick={onSelectHighlighter}
                    />
                  </span>
                  {enableHighlightEraser ? (
                    <span
                      className={`footer-size ${
                        showHighlightEraser ? 'cmsFooter__tools-border' : ''
                      }`}
                    >
                      <img
                        src={Eraser}
                        alt='eraser'
                        onClick={onClickHighlightEraser}
                        style={{
                          cursor: 'pointer'
                        }}
                      />
                    </span>
                  ) : (
                    <span className='footer-size'>
                      <img src={Eraser} alt='eraser' style={{ opacity: 0.5 }} />
                    </span>
                  )}
                  <button type='button' onClick={props.onRemoveAllHighlights}>
                    Clear All
                  </button>
                  <button
                    onClick={onCloseHighlightTooltip}
                    type='button'
                    className='closeTooltipBtn'
                  >
                    <img src={Close} alt='Close' />
                  </button>
                </div>
              )}
              <span
                className={`cmsFooter__tools ${
                  showHighlighterTooltip ? 'cmsFooter__tools-border' : ''
                }`}
              >
                <Highlighter
                  style={{ cursor: 'pointer' }}
                  onClick={() => onClickHighlighter(!showHighlighterTooltip)}
                />
              </span>
            </div>

            <div style={{ position: 'relative' }}>
              {showPencilTooltip && (
                <div className='edit-options-tooltip'>
                  <span
                    className={`cmsFooter__tools ${
                      isPencilActive ? 'cmsFooter__tools-border' : ''
                    }`}
                  >
                    <img
                      alt='Pencil'
                      style={{ cursor: 'pointer' }}
                      src={RedMarker}
                      onClick={onSelectPencil}
                    />
                  </span>
                  {isScreenMarked ? (
                    <span
                      className={`footer-size ${
                        enableEraser ? 'cmsFooter__tools-border' : ''
                      }`}
                    >
                      <img
                        src={Eraser}
                        alt='eraser'
                        onClick={onClickEraser}
                        style={{
                          cursor: 'pointer'
                        }}
                      />
                    </span>
                  ) : (
                    <span className='footer-size'>
                      <img src={Eraser} alt='eraser' style={{ opacity: 0.5 }} />
                    </span>
                  )}
                  <button onClick={onClearAllPencil}>Clear All</button>
                  <button
                    onClick={onClosePencilTooltip}
                    type='button'
                    className='closeTooltipBtn'
                  >
                    <img src={Close} alt='Close' />
                  </button>
                </div>
              )}
              <span
                className={`cmsFooter__tools ${
                  showPencilTooltip ? 'cmsFooter__tools-border' : ''
                }`}
              >
                <img
                  alt='Pencil'
                  style={{ cursor: 'pointer' }}
                  src={RedMarker}
                  onClick={() => onClickPencil(!showPencilTooltip)}
                />
              </span>
            </div>
            <span
              className={`footer-size ${
                showCalculator ? 'footer__tools-border' : ''
              }`}
            >
              {isCalculatorAllowed && isMath && (
                <img
                  className='calculator-icon'
                  id='calculator'
                  onClick={onClickCalculator}
                  style={{ cursor: 'pointer' }}
                  src={Calculator}
                  alt='Calculator'
                />
              )}
            </span>
          </div>

          <div className='d-flex align-items-center gap-4'>
            {isMath && formulaSheet && (
              <button
                type='button'
                className='formula-sheet-btn'
                onClick={onClickFormulaSheet}
              >
                <img src={OpenLink} alt='Formula' />
                <span className='cursor-pointer'>Formula Sheet</span>
              </button>
            )}
            <div className='cmsFooter__buttons'>
              <div className='cmsFooter__buttons-wrapper'>
                <button
                  disabled={
                    isPausedByTeacher || currentQuestion.answer === null
                  }
                  onClick={() => {
                    clearPencil()
                    setShowClearModal(true)
                  }}
                  className='btn cancel-btn btn-medium'
                >
                  Clear
                </button>
                <button
                  onClick={() => {
                    clearPencil()
                    audioRef.current?.paused === false &&
                      audioRef.current?.pause()
                    setShowPauseExitModal(true)
                  }}
                  className='btn orange-btn light btn-medium'
                >
                  Pause/Exit
                </button>
                <button
                  disabled={isPausedByTeacher || !hasPreviousQuestion}
                  onClick={() => {
                    clearPencil()
                    previousQuestion()
                  }}
                  className='btn cancel-btn btn-medium'
                >
                  Back
                </button>
                <button
                  disabled={isPausedByTeacher || !hasNextQuestion}
                  onClick={() => {
                    clearPencil()
                    nextQuestion()
                  }}
                  className='btn cancel-btn btn-medium'
                >
                  Next
                </button>
                <button
                  disabled={isPausedByTeacher || hasNextQuestion}
                  onClick={onClickFinish}
                  className='btn success-btn btn-medium'
                >
                  Finish
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
